import React from 'react';
import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import { usePageTransition } from '../../utils/pageTransitions';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import HeroSection from './components/HeroSection';
import CarouselSection from './components/CarouselSection';
import ServicesGrid from './components/ServicesGrid';
import TestimonialCarousel from './components/TestimonialCarousel';
import ServiceFinder from './components/ServiceFinder';
import TrustIndicators from './components/TrustIndicators';
import CTASection from './components/CTASection';
import WhatsAppButton from './components/WhatsAppButton';

const Homepage = () => {
  const { variants, transition } = usePageTransition();

  return (
    <>
      <Helmet>
        <title>ORAZEK Investment - Solutions d'Affaires Complètes en RDC</title>
        <meta
          name="description"
          content="Leader des solutions professionnelles en République Démocratique du Congo. Immobilier, IT, juridique, événements et plus. Plus de 500 clients satisfaits."
        />
        <meta
          name="keywords"
          content="ORAZEK, RDC, Congo, services professionnels, immobilier Kinshasa, location véhicules, solutions IT, conseil juridique"
        />
        <meta property="og:title" content="ORAZEK Investment - Votre Partenaire de Confiance en RDC" />
        <meta property="og:description" content="Solutions complètes pour votre entreprise en République Démocratique du Congo" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://orazek.com/homepage" />
      </Helmet>
      <div className="min-h-screen bg-white dark:bg-slate-900">
        <Header />

        <motion.main
          className="main-content"
          initial="initial"
          animate="animate"
          exit="exit"
          variants={variants}
          transition={transition}
        >
          <HeroSection />
          <CarouselSection />
          <ServicesGrid />
          <ServiceFinder />
          <TestimonialCarousel />
          <TrustIndicators />
          <CTASection />
        </motion.main>

        <Footer />
        <WhatsAppButton />
      </div>
    </>
  );
};

export default Homepage;